import { FirebaseDocRefType } from 'firebase/index'

/**
 * 権限情報
 * 9: 管理者
 * 5: スタッフ
 * 1: 閲覧のみ(ビューワー)
 */

export class Role {
  readonly role: number
  store_ref: FirebaseDocRefType | undefined

  constructor(role: number, storeRef?: FirebaseDocRefType) {
    this.role = role
    this.store_ref = storeRef ? storeRef : undefined
  }

  // 操作可能な権限かを判定
  hasEnoughRole(requiredRole: number, isAdmin?: boolean): boolean {
    return isAdmin || this.role >= requiredRole
  }

  hasRoleOfStore(storeRef: FirebaseDocRefType): boolean {
    return this.store_ref === storeRef
  }

  getRole(): number {
    return this.role
  }
}
